import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
// redux
import { connect, useDispatch, useSelector } from 'react-redux';

// @material-ui/core
import { Hidden, makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

// shared core components
import Loader from '../../../shared/components/Loader/LoaderContent';
import NothingFound from '../../../shared/components/NothingFound/NothingFound';
import { getCompanyNoDuplicate, newFilterByCompany} from '../filterByCompany'
import * as imageSource from '../../../shared/utils/imageSource';
import { log } from '../../../shared/utils/console.js'
import { validateMembership } from '../../../shared/utils/membershipUtils';
import { manuallyAttemptMembershipPayment as attemptMembershipPayment } from '../../../shared/utils/membershipRepurchase.js';
import { convertSourceToImageResource } from '../../../constants/placeholderImages.js';
import { SOURCES } from '../../../shared/constants/sources';
import { redirectMembershipView } from '../../../shared/utils/membershipUtils';

// Redux actions
import { applyCart, applyCartProducts } from '../../../redux/actions/cartActions.js';
import { setActiveTab, setActiveSubTab } from '../../../redux/actions/tabsActions';
import { CART } from '../../../routes/paths';

// services
import { CourseService, MembershipService } from '@sdk-point/talisis'

// Design system
import StatusCourseCard from '../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard.jsx';
import { getSourceBySourceAndCompany } from '../../../design-system/utils/source.js';

const useStyles = makeStyles((theme) => ({
    root_carousel:{
        maxWidth: "1300px",
        width: "100%",
        marginLeft: "auto", 
        marginRight: "auto",
    },
    card: {
        maxWidth: "326px",
    },
    card_content:{
        width: "288px",
        minHeight: "315px",
        maxHeight: "315px",
        backgroundColor: "#1c1f24",
        "&:hover": {
            cursor:"pointer",
            "& $continuar_content": {
                opacity: "1",
                transition: "0.5s"
            },
        },
        
    },
    schedule:{
        display: 'flex',
        justifyContent: 'space-between',
        '& span':{
            display: 'flex',
            alignItems: 'center',
            fontSize: 12,
            fontWeight: 400
        }
    },
    chip:{
        height: 20
    },
    cardActionArea:{
        
    },
    focusHighlight: {
       
    },
    title:{
        marginLeft: "59px",
        width: "100%",
        "@media (max-width: 1250px)": {
            marginLeft: "5px",
        },
    },
    continuar_text:{
        fontFamily: 'Inter',
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "16px",
        lineHeight: "24px",
        color: "#FFFFFF",
    },
    rootTitles: {
        display:"flex",
        flexWrap:"wrap",
        justifyContent:"space-between",
        [theme.breakpoints.down('xs')]:{
            marginTop: '16px',
            marginBottom: '16px'
        }
    },
    rootCardsStyle:{
        display: 'flex',
        flexDirection: 'row',
        width: 'fit-content',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '100%',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        paddingBottom: '32px',
        [theme.breakpoints.down('xs')]:{
            gap: 16,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }
}));

const SavedCourses = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { user, isMyCourses } = props;
    const { cart } = useSelector((state) => state.cartReducer);
    const [filter, setFilter] = useState([]);
    const [courses, setCourses] = React.useState([]);
    const [coursesAll, setCoursesAll] = React.useState([]);
    const [charge, setCharge] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [userMembership, setUserMembership] = React.useState(null);
    const [userAddOn, setUserAddOn] = React.useState(null);
    const [loadingRepurchase, setLoadingRepurchase] = React.useState(false);

    const courseService = new CourseService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);
    const membershipService = new MembershipService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

    const alliesFree = [SOURCES['GOOGLE'], SOURCES['HUBSPOT']];

    const manuallyAttemptMembershipPayment = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        redirectMembershipView(e, dispatch, history)
        await attemptMembershipPayment({
            userMembership,
            userAddOn,
            cart,
            user,
            dispatchCart: dispatch,
            applyCart,
            applyCartProducts,
            history,
            cartPath: CART,
            setLoadingRepurchase,
        });
    };

    const getData = async () => {
        try {
            setLoading(true);
            const courses = await courseService.getUserFavoriteCourses(user?.person_id);
            setFilter(()=> getCompanyNoDuplicate(courses?.response))
            log(JSON.stringify(courses?.response))
            return courses?.response;
        } catch (e) {
            log('Ops! error al get courses saved',e.message);
        }
    };

    React.useEffect(() => { 
        let isCanceled = true;

        const init = async () => {
            // Load membership
            try {
                const personMembershipDetail = await membershipService.getPersonMembershipDetail(user?.person_id);
                setUserMembership(personMembershipDetail?.userMembership);
                setUserAddOn(personMembershipDetail?.userAddOn);
            } catch (e) {
                log('Error loading membership', e.message);
            }

            // Load courses
            const data = await getData();
            if (isCanceled) {
                const transformed = transformDataPriceMembership(data);
                setCourses(transformed?.slice());
                setCoursesAll(transformed?.slice());
                setLoading(false);
                setCharge(true);
            }
        };

        init().catch((err) => log(`Failed: ${err}`));
        return () => (isCanceled = false);
    }, []);

    const handleClick = (e, filterSelected) => {
        e.preventDefault()
        if(typeof filterSelected.id === 'number') {
          if(filterSelected.id===0) {
            setCourses(()=> coursesAll)
          } else {
            const COURSES_FILTER_BY_SOURCE = coursesAll.filter((course)=> course.source === filterSelected.id)
            setCourses(()=> COURSES_FILTER_BY_SOURCE)
          }
        } else {
           const COURSES_FILTER_BY_COMPANY = coursesAll.filter((course)=> course.company === filterSelected.id)
           setCourses(()=> COURSES_FILTER_BY_COMPANY)
        } 
        setFilter(()=> newFilterByCompany(filter, filterSelected));
    }

    function transformDataPriceMembership(data){
        return data.map(course =>({
            ...course,
            source_id: course.source,
            priceMembershipActions: true,
            price: {
                number: course.price,
                listNumber: course.list_price,
            },
            image_url: course.image_url || imageSource.convertSourceToImageResource(course.company, course.source)
        }));
    }

    return (
        <Loader loading={loading} transparent={true} minHeight="500px">
            <Box className={classes.root_carousel}>
                <Box className={classes.rootTitles}>
                    <Hidden smDown>
                        <Box>
                            <Typography className="font-size-24 font-weight-700" color="white">Tus cursos guardados</Typography>
                        </Box>
                    </Hidden>
                    <Box>
                        {  filter.map((filter, index) => {
                                return (
                                    <Chip key={index+filter.label} 
                                        label={filter.label} 
                                        onClick={((e) => handleClick(e, filter))}
                                        value={filter}
                                        clickable style={{
                                                    width: "auto",
                                                    height: "32px",
                                                    background: filter.active,
                                                    border: "0.5px solid #404150",
                                                    borderRadius: "24px",
                                                    gap: "10px",
                                                    marginRight:5,
                                                    fontSize:12,
                                                    color: "#EBEBEB"
                                                    }}/>
                                );
                            }) 
                        }
                    </Box> 
                </Box>
                <Box style={{paddingTop: '24px'}}>
                    {courses?.length > 0 ? 
                        <Grid container spacing={3}>
                            {
                                courses.map((courseItem) => (
                                    <Grid item lg={3} md={4} sm={6} xs={12} key={courseItem.id} className="d-flex justify-content-center">
                                        <StatusCourseCard
                                            courseId={courseItem.id}
                                            sourceId={courseItem.source_id}
                                            userId={parseInt(user?.person_id ?? 0)}
                                            sourceIdLogo={getSourceBySourceAndCompany(courseItem.source_id, courseItem.company)}
                                            enrollmentStatusId={courseItem?.enrollment_status_id}
                                            media={{
                                                backgroundImage: courseItem?.image_url || convertSourceToImageResource(courseItem.company, courseItem.source_id),
                                                modalityId: courseItem?.modality_id || 2,
                                            }}
                                            content={{
                                                courseName: courseItem?.name,
                                            }}
                                            companyId={courseItem?.company}
                                            onClickGoToCourse={() => history.push(`/course/${courseItem.id}`)}
                                            approved={false}
                                            onClickRegister={() => history.push(`/course/${courseItem.id}`)}
                                            showDetailButton={
                                                false
                                            }
                                            handleRenovationMembership={(e) => redirectMembershipView(e, dispatch, history)}
                                            merbershipIsExpired={
                                                alliesFree.includes(courseItem.source_id) || courseItem.price?.number === 0 ? false : validateMembership(userMembership)
                                            }
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                        :<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            {charge && <NothingFound
                                        caption={"No cuentas con cursos guardados"}
                                        subcaption={"Aquí encontrarás el contenido que hayas guardado"}
                                        type={"completed-courses"}
                                    /> }
                        </Box>
                    }
                </Box>
            </Box>
        
        </Loader>
    );
};

SavedCourses.defaultProps = {
    lazyLoading: false,
    disableTitleAction: false,
};

const mapStateToProps = (reducers) => reducers.userReducer;
const mapDispatchToProps = { setActiveTab, setActiveSubTab };

export default connect(mapStateToProps, mapDispatchToProps)(SavedCourses);
